import {
	emailValidation,
	getTeamMemberRoleLabel,
	type IApiResponse,
	type IDropDownItem,
	type ITeamMemberData,
	type IUseModalApi,
} from 'BreetHelpers';
import * as yup from 'yup';

export const InviteTeamMemberSchema = yup.object({
	fullName: yup.string().required('Full name is required'),
	email: emailValidation,
	role: yup.string().required('Role is required'),
});

export type InviteTeamMemberSchemaType = yup.InferType<typeof InviteTeamMemberSchema>;

export const roleOptions: IDropDownItem[] = [
	{
		value: 'owner',
		code: '',
		name: getTeamMemberRoleLabel('owner'),
		icon: '',
	},
	{
		value: 'super_admin',
		code: '',
		name: getTeamMemberRoleLabel('super_admin'),
		icon: '',
	},
	{
		value: 'subadmin',
		code: '',
		name: getTeamMemberRoleLabel('subadmin'),
		icon: '',
	},
	{
		value: 'developer',
		code: '',
		name: getTeamMemberRoleLabel('developer'),
		icon: '',
	},
	{
		value: 'customer_support',
		code: '',
		name: getTeamMemberRoleLabel('customer_support'),
		icon: '',
	},
];

export const statusOptions: IDropDownItem[] = [
	{
		value: 'active',
		code: '',
		name: 'Active',
		icon: '',
	},
	{
		value: 'unverified',
		code: '',
		name: 'Unverified',
		icon: '',
	},
	{
		value: 'deleted',
		code: '',
		name: 'Deleted',
		icon: '',
	},
];

export interface IInviteTeamMemberChild {
	teamMemberData?: IApiResponse<ITeamMemberData>;
	modalApis: IUseModalApi;
}

export const TEAM_MEMBER_PERMISSIONS: Record<
	'super_admin' | 'owner',
	{
		all: string[];
		self: string[];
		owner?: string[];
	}
> = {
	super_admin: {
		all: ['view', 'edit', 'delete'],
		self: ['view'],
		owner: ['view'],
	},
	owner: {
		all: ['view', 'edit', 'delete'],
		self: ['view'],
	},
};
